import { render, staticRenderFns } from "./customerCenter.vue?vue&type=template&id=41962df6&scoped=true&"
import script from "./customerCenter.vue?vue&type=script&lang=js&"
export * from "./customerCenter.vue?vue&type=script&lang=js&"
import style0 from "./customerCenter.vue?vue&type=style&index=0&id=41962df6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41962df6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41962df6')) {
      api.createRecord('41962df6', component.options)
    } else {
      api.reload('41962df6', component.options)
    }
    module.hot.accept("./customerCenter.vue?vue&type=template&id=41962df6&scoped=true&", function () {
      api.rerender('41962df6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customerService/customerCenter.vue"
export default component.exports